export function formatPriceInMillions(price?: number | null, isRTL?: boolean): string {
  if (price === undefined || price === null || Number.isNaN(price)) {
    return '';
  }
  
  const inMillions = price / 1_000_000;
  // Format to up to 2 decimal places, removing trailing zeros
  // e.g., 1.50 -> 1.5, 1.75 -> 1.75, 1.00 -> 1
  const formatted = Number.parseFloat(inMillions.toFixed(2)).toString();
  
  return isRTL ? `${formatted} م` : `${formatted} M`;
}
